import { z } from "zod"

// Utility to normalize URLs
export const normalizeUrl = (input: string): string => {
   let cleaned = input.trim().toLowerCase()

   // Remove leading/trailing whitespace and common typos
   cleaned = cleaned.replace(/^https?:\/\//, "")

   // If it's empty or invalid, return an empty string (to be caught by validation)
   if (!cleaned) return ""

   // Basic domain validation (at least one dot and no spaces)
   if (!cleaned.includes(".") || cleaned.includes(" ")) {
      return cleaned // Return as-is for validation to fail
   }

   // Add https:// prefix
   return `https://${cleaned}`
}

export const flexibleUrlSchema = z
   .string()
   .min(1, "URL is required")
   .transform((val) => normalizeUrl(val)) // Normalize to https://{url}
   .refine(
      (val) => {
         try {
            new URL(val) // Ensure it's a valid URL after normalization
            return true
         } catch {
            return false
         }
      },
      {
         message: "Invalid URL format. Please enter a valid URL (e.g., test.com or https://test.com)",
      },
   )
